"use client";

import { useEffect } from "react";

import type { PublicPageBrand } from "@/lib/public-brand-theme";
import {
  ROMA_FUNNEL_DATA_ATTR,
  ROMA_FUNNEL_ON_VALUE,
  shouldApplyRomaDarkFunnel,
} from "@/lib/roma-funnel-tokens";

type PublicLightThemeInitProps = {
  pageBrand?: PublicPageBrand;
  /** Server-resolved kill switch — authoritative over client-inlined env. */
  romaFunnelEnabled?: boolean;
};

function isRomaDarkFunnelActive(
  pageBrand?: PublicPageBrand,
  romaFunnelEnabled?: boolean,
): boolean {
  if (typeof romaFunnelEnabled === "boolean") {
    return pageBrand === "chefs-roma" && romaFunnelEnabled;
  }

  if (pageBrand && shouldApplyRomaDarkFunnel(pageBrand)) {
    return true;
  }

  return Boolean(
    document.querySelector(
      `[${ROMA_FUNNEL_DATA_ATTR}="${ROMA_FUNNEL_ON_VALUE}"]`,
    ),
  );
}

export function PublicLightThemeInit({
  pageBrand,
  romaFunnelEnabled,
}: PublicLightThemeInitProps) {
  useEffect(() => {
    if (isRomaDarkFunnelActive(pageBrand, romaFunnelEnabled)) {
      return;
    }

    const root = document.documentElement;
    root.classList.remove("dark");
    root.classList.add("light");
    root.style.colorScheme = "light";
  }, [pageBrand, romaFunnelEnabled]);

  return null;
}
